import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '../context/SiteSettingsContext';

const SITE_NAME = 'IDMAT Service';
const DEFAULT_IMAGE = 'https://images.pexels.com/photos/2058729/pexels-photo-2058729.jpeg?auto=compress&cs=tinysrgb&w=1200';
const SITE_URL = 'https://field.idmatoi.com';

// Map page canonical path → CMS meta description field
const META_DESC_FIELD_MAP = {
  '/':            'home_meta_description',
  '/reparation':  'repair_meta_description',
  '/peinture':    'paint_meta_description',
  '/entretien':   'maintenance_meta_description',
  '/prestations': 'prestations_meta_description',
  '/contact':     'contact_meta_description',
};

const SEO = ({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  noindex = false,
}) => {
  const { settings } = useSiteSettings();

  // Use CMS dynamic description if available, fallback to prop
  const dynamicDesc = canonical && settings?.[META_DESC_FIELD_MAP[canonical]];
  const finalDescription = dynamicDesc || description;

  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} | Réparation & Peinture Engins de Chantier - La Réunion`;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL;

  return (
    <Helmet>
      {/* Base */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Langue & Géo */}
      <meta httpEquiv="content-language" content="fr-RE" />
      <meta name="geo.region" content="RE" />
      <meta name="geo.placename" content="Saint-Leu, La Réunion" />
      <meta name="geo.position" content="-21.1699;55.2739" />
      <meta name="ICBM" content="-21.1699, 55.2739" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="fr_RE" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
